import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const CouponsSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "CouponsSettingsPage" */ "@circle-react/components/SettingsApp/Coupons"
    ),
);

export const CouponsSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <CouponsSettingsComponent />
  </Suspense>
);
